import { useAuth } from "#/hook/useAuth";
import { Button } from "@mantine/core";
import { IconLock, IconLogout } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function UnauthorizedPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <div className="w-full h-screen flex items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-center max-w-md">
        <IconLock size={64} className="text-gray-400" />
        <h1 className="text-3xl font-bold text-black">{t("auth.unauthorized.title")}</h1>
        <p className="text-gray-600">
          {t("auth.unauthorized.description")}
        </p>
        <div className="flex gap-2">
          <Button
            color="black"
            variant="outline"
            onClick={() => navigate("/dashboard")}
          >
            {t("auth.unauthorized.goToDashboard")}
          </Button>
          <Button
            color="red.5"
            variant="light"
            onClick={logout}
            leftSection={<IconLogout size={16} />}
          >
            {t("auth.unauthorized.logout")}
          </Button>
        </div>
      </div>
    </div>
  );
}
